<template>
  <div class="forecast-wrap">
    <div
      class="forecast-wrap-title"
      style="border-bottom: 1px solid rgba(0, 0, 0, 0.08)"
    >
      <card-title
        :title="title"
        :is-more="isMore"
        @onClickMainTitleMore="onClickMainTitleMore"
      />
    </div>
    <div class="forecast-wrap-content">
      <div v-if="predict" @click="handleGoRoad">
        <card-sub-title :title="congestedRoad" :is-sub-more="isSubMore" />
        <ul class="forecast-info">
          <!--   2021.09.01根据产品要求，重上最堵道路   -->
          <li
            v-if="morningLevel || predict.morningCongestRoad"
            class="forecast-info-tomorrow"
          >
            · 预计
            <div v-if="morningLevel">
              明日早高峰（7点-9点）辖区内<span
                :style="{ color: morningState }"
                >{{ morningLevel }}</span
              >，
            </div>
            <div v-if="predict.morningCongestRoad">
              最堵道路为<span>{{ predict.morningCongestRoad }}</span
              >。
            </div>
          </li>
          <li
            v-if="eveningLevel || predict.eveningCongestRoad"
            class="forecast-info-tomorrow"
          >
            · 预计
            <div v-if="eveningLevel">
              晚高峰（17点-19点）辖区内<span :style="{ color: eveningState }">{{
                eveningLevel
              }}</span
              >，
            </div>
            <div v-if="predict.eveningCongestRoad">
              最堵道路为<span>{{ predict.eveningCongestRoad }}</span
              >。
            </div>
          </li>
          <li
            v-if="morningCongestDay || eveningCongestDay"
            class="forecast-info-week"
            :class="{ noPadding: !hotPlaces }"
          >
            · 未来7天
            <div v-if="morningCongestDay">
              <span class="wall">{{ morningCongestDay }}</span
              >早高峰最堵，
            </div>
            <div v-if="eveningCongestDay">
              <span class="wall">{{ eveningCongestDay }}</span
              >晚高峰最堵，建议关注
            </div>
          </li>
        </ul>
      </div>
      <div
        v-if="predict && hotPlaces"
        class="forecast-wrap-divider"
        style="border-top: 1px solid rgba(0, 0, 0, 0.08)"
      />
      <div v-if="hotPlaces" @click="handleGoDestination">
        <card-sub-title :title="popularDestinations" :is-sub-more="isSubMore" />
        <ul class="forecast-info">
          <li v-if="hotPlaces.sceneName" class="forecast-info-tomorrow">
            · 最热门景区是<span class="hot-color">{{
              hotPlaces.sceneName
            }}</span
            >，热度持续<span :style="{ color: scenicColor }">{{
              hotPlaces.sceneTendency
            }}</span>
          </li>
          <li v-if="hotPlaces.trafficPointName" class="forecast-info-tomorrow">
            · 最热门交通枢纽是<span class="hot-color">{{
              hotPlaces.trafficPointName
            }}</span
            >，热度持续<span :style="{ color: hubColor }">{{
              hotPlaces.trafficPointTendency
            }}</span>
          </li>
          <li
            v-if="hotPlaces.businessName"
            class="forecast-info-week noPadding"
          >
            · 最热门商圈是<span class="hot-color">{{
              hotPlaces.businessName
            }}</span
            >，热度持续<span :style="{ color: businessColor }">{{
              hotPlaces.businessTendency
            }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { webviewInfo, log } from '@ali/amap-lib';
import CardTitle from './CardTitle';
import CongestionUtils from '../utils/CongestionUtils';
import ForecastUtils from '../utils/ForecastUtils';
import CardSubTitle from './CardSubTitle';
import jumpHandler from '../../../../../common/js/jump-handler';

export default {
  name: 'TrafficForecast',
  components: {
    CardSubTitle,
    CardTitle
  },
  props: {
    predictData: {
      type: Object,
      default: () => null
    },
    cityName: {
      type: String,
      default: () => null
    },
    unitId: {
      type: Number,
      default: () => null
    },
    logParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: '交通预测',
      congestedRoad: '拥堵路段',
      popularDestinations: '未来热门目的地',
      isMore: true,
      isSubMore: false,
      predict: this.predictData.predict,
      // hotPlaces: this.predictData.hot,
      // 2022.06.30 @周钰铭 需求 隐藏’未来热门目的地‘模块
      hotPlaces: false,
      morningLevel: null,
      morningState: null,
      eveningLevel: null,
      eveningState: null,
      morningCongestDay: null,
      eveningCongestDay: null,
      scenicColor: null,
      hubColor: null,
      businessColor: null
    };
  },

  watch: {
    predictData() {
      this.getStateColor();
      this.getDay();
      this.getHeatColor();
    }
  },

  mounted() {
    this.getStateColor();
    this.getDay();
    this.getHeatColor();
  },
  methods: {
    // 跳转交通号首页
    onClickMainTitleMore() {
      const { pageType, type, unitId } = this.logParams;
      log.log('card_click', { page_type: pageType, type, album_id: unitId });
      const url = new URL('https://jiaotonghao2.amap.com?channel=amap&src=h5_lbp_push');
      const { searchParams } = url;
      searchParams.append('unitId', this.unitId);
      jumpHandler(url, { needSchema: !!webviewInfo.isInAmap(), hideTitleBar: true });
    },
    handleGoRoad() {
      this.onClickMainTitleMore();
    },
    // 跳转交通号首页
    handleGoDestination() {
      const { pageType, type, unitId } = this.logParams;
      log.log('card_click', { page_type: pageType, type, album_id: unitId });
      const url = new URL('https://jiaotonghao2.amap.com?channel=amap&src=h5_lbp_push');
      const { searchParams } = url;
      searchParams.append('unitId', this.unitId);
      jumpHandler(url, { needSchema: !!webviewInfo.isInAmap(), hideTitleBar: true });
    },
    // 获取拥堵等级及色值
    getStateColor() {
      if (this.predictData && this.predict.morningCongestIndex) {
        const level = CongestionUtils.regionalCongestionLevel(this.predict.morningCongestIndex);
        const statusMo = CongestionUtils.getCongestionColor(level);
        this.morningState = statusMo[0].color;
        this.morningLevel = statusMo[0].desc;
      }
      if (this.predictData && this.predict.eveningCongestIndex) {
        const levelEv = CongestionUtils.regionalCongestionLevel(this.predict.eveningCongestIndex);
        const statusEv = CongestionUtils.getCongestionColor(levelEv);
        this.eveningState = statusEv[0].color;
        this.eveningLevel = statusEv[0].desc;
      }
    },
    // 时间转换
    getDay() {
      this.morningCongestDay = this.predictData
        && this.predict.morningCongestDay
        && this.$moment(this.predict.morningCongestDay).format('MM月DD日');
      this.eveningCongestDay = this.predictData
        && this.predict.eveningCongestDay
        && this.$moment(this.predict.eveningCongestDay).format('MM月DD日');
    },
    // 热门目的地色值
    getHeatColor() {
      if (this.predictData && this.hotPlaces) {
        const { sceneTendency, trafficPointTendency, businessTendency } = this.hotPlaces;
        this.scenicColor = sceneTendency && ForecastUtils.getForecastColor(sceneTendency)[0].color;
        this.hubColor = trafficPointTendency && ForecastUtils.getForecastColor(trafficPointTendency)[0].color;
        this.businessColor = businessTendency && ForecastUtils.getForecastColor(businessTendency)[0].color;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../common/css/common-mixin";
.forecast-wrap {
  padding: rpx(24) 0 rpx(28) 0;
  background: #fafafa;
  border-radius: rpx(24);
  margin-top: rpx(20);
  &-title {
    padding: 0 rpx(24) rpx(16);
    // border-bottom: 1px solid var(--default-secondary-border-color);
  }
  &-content {
    padding: 0 rpx(24);
  }
  .forecast-info {
    &-tomorrow,
    &-week {
      padding-top: rpx(16);
      font-size: rpx(24);
      color: rgba(0, 0, 0, 0.9);
      line-height: rpx(33);
      font-weight: normal;
      div {
        display: inline;
      }
    }
    &-tomorrow {
      span {
        font-weight: bold;
      }
      .hot-color {
        color: #ff4b4b;
      }
    }
    &-week {
      padding-bottom: rpx(24);
      span {
        font-weight: bold;
      }
      .wall {
        color: #f47a23;
      }
      .hot-color {
        color: #ff4b4b;
      }
    }
  }
  .noPadding {
    padding-bottom: 0;
  }
}
</style>
